/**
 * Типы движков рендеринга
 */
export const RenderEnginesEnum = {
    /**
     * Старый (Legacy)
     */
    legacy: 'legacy',
    /**
     * Новый (Jinja2)
     */
    jinja2: 'jinja2',
};
